// Port of api/fuel/app/classes/controller/api/monty/accounts/forgot.php
import Constants from 'offline/constants'
import User from 'offline/model/user'

export default function(params) {
	var name = String(params.name || '').trim().toLowerCase()
	var key = params.key || false
	var user

	if (key) {
		user = User.with('user_verification_key', key)

		if (!user) {
			return Promise.reject({ error: Constants.API_ERROR_USER_KEY_INVALID, offline: true })
		}

		return Promise.resolve({
			session: { offline: true },
			data: { username: user.get_name() }
		})
	}

	if (!name) {
		return Promise.reject({ error: Constants.API_ERROR_USER_INVALID, offline: true })
	}

	user = User.with('user_name', name)

	if (!user) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOTFOUND, offline: true })
	}

	if (!user.is_registered()) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOTREGISTERED, offline: true })
	}

	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
